import { jsxs as I, jsx as O } from "react/jsx-runtime";
import { u as r } from "./index-6a632112.mjs";
import { useRef as B, useState as A, useEffect as C, useCallback as w } from "react";
import { useWindowDimensions as V } from "./useWindowDimensions.js";
import { b as Z, r as q, l as J, Q as K } from "./themes-5f0b3c3d.mjs";
import { z as U } from "./zIndices-d07533f3.mjs";
import { g as N } from "./getElementPosition-5026bb28.mjs";
var e = /* @__PURE__ */ ((t) => (t.AUTO = "auto", t.TOP = "top", t.BOTTOM = "bottom", t.LEFT = "left", t.RIGHT = "right", t.TOP_START = "top-start", t.TOP_END = "top-end", t.BOTTOM_START = "bottom-start", t.BOTTOM_END = "bottom-end", t.RIGHT_START = "right-start", t.RIGHT_END = "right-end", t.LEFT_START = "left-start", t.LEFT_END = "left-end", t))(e || {});
const X = 5, G = r.span`
  --pointer-size: calc(${X} / 16 * 1rem);
  --border-color: ${(t) => t.theme.components.tooltip.borderColor};
  --border-size: ${Z["1x"]};
  --background-color: ${(t) => t.theme.components.tooltip.backgroundColor};
`, l = r(G)`
  position: absolute;
  z-index: 116;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;

  &::after,
  &::before {
    border: solid transparent;
    border-color: transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
  }

  &::after {
    border-top-color: var(--background-color);
    border-width: var(--pointer-size);
    margin-left: calc(var(--pointer-size) * -1);
  }

  &::before {
    border-top-color: var(--border-color);
    border-width: calc(var(--pointer-size) + var(--border-size));
    margin-left: calc((var(--pointer-size) + var(--border-size)) * -1);
  }
`, tt = r(l)`
  top: 100%;
  left: 50%;
  transform: translateY(calc(var(--border-size) * -1));
`, rt = r(l)`
  bottom: 100%;
  left: 50%;
  transform: rotate(180deg) translateY(calc(var(--border-size) * -1));
`, et = r(l)`
  left: 100%;
  top: 50%;
  transform: rotate(270deg) translateY(calc(var(--border-size) * -1));
`, ot = r(l)`
  right: 100%;
  top: 50%;
  transform: rotate(90deg) translateY(calc(var(--border-size) * -1));
`, nt = r(l)`
  top: 100%;
  left: 10%;
  transform: translateY(calc(var(--border-size) * -1));
`, at = r(l)`
  top: 100%;
  left: 90%;
  transform: translateY(calc(var(--border-size) * -1));
`, st = r(l)`
  right: 100%;
  top: 25%;
  transform: rotate(90deg) translateY(calc(var(--border-size) * -1));
`, it = r(l)`
  right: 100%;
  top: 75%;
  transform: rotate(90deg) translateY(calc(var(--border-size) * -1));
`, lt = r(l)`
  bottom: 100%;
  left: 10%;
  transform: rotate(180deg) translateY(calc(var(--border-size) * -1));
`, ct = r(l)`
  bottom: 100%;
  left: 90%;
  transform: rotate(180deg) translateY(calc(var(--border-size) * -1));
`, ft = r(l)`
  left: 100%;
  top: 25%;
  transform: rotate(270deg) translateY(calc(var(--border-size) * -1));
`, pt = r(l)`
  left: 100%;
  top: 75%;
  transform: rotate(270deg) translateY(calc(var(--border-size) * -1));
`, dt = r(G)`
  width: 1px;
  height: calc(var(--pointer-size) * 2);
  display: inline-block;
  visibility: hidden;
  position: absolute;
  top: calc(var(--pointer-size) * -1);
  right: calc(var(--border-size) / 2);
  z-index: 1;
  transform: rotate(90deg);
  background: var(--background-color);
`, ut = r.div`
  max-width: 250px;
  background-color: ${(t) => t.theme.components.tooltip.backgroundColor};
  border: 1px solid ${(t) => t.theme.components.tooltip.borderColor};
  color: ${(t) => t.theme.components.tooltip.textColor};
  position: relative;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  width: 100%;
  white-space: nowrap;
  padding: 8px 12px;
  border-radius: ${q["1x"]};
  box-shadow: ${(t) => t.theme.components.tooltip.boxShadow};
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: calc((14 / 16) * 1rem);
  font-family: ${(t) => t.theme.typography.primaryFont};
  box-sizing: border-box;
  letter-spacing: ${J[0]};
  line-height: calc((20 / 16) * 1rem);
  text-align: center;

  ${(t) => {
  if (t.$showLargeContent)
    return ` 
      white-space: normal;
      max-width: max-content;
      width: 400px;
      @media ${K.tabletAndUp}{
        width: 500px;
      }
      `;
}}
`, bt = (t) => t === "top" || t === "bottom" ? "translate(-50%)" : t === "top-start" || t === "bottom-start" ? "translate(-95%)" : t === "top-end" || t === "bottom-end" ? "translate(-5%)" : t === "right-start" || t === "left-start" ? "translate(0, -80%)" : t === "right-end" || t === "left-end" ? "translate(0, -20%)" : t === "right" || t === "left" ? "translate(0, -50%)" : null, mt = (t) => t === "top" || t === "bottom" ? "translate(-50%, -8px)" : t === "top-start" || t === "bottom-start" ? "translate(-100%)" : t === "left" ? "translate(8px, -50%)" : t === "right" ? "translate(-8px, -50%)" : null, y = r.div`
  position: ${(t) => t.$exceedOverflow ? "fixed" : "absolute"};
  display: var(--display);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  z-index: ${U.tooltip};
  --pointer-gap: calc((18 / 16 * 1rem));

  display: ${({ $isOpen: t }) => t ? "block" : "none"};
  --translate: ${({ $isOpen: t, $position: m = "" }) => t ? bt(m) : mt(m)};
`, L = r(y)`
  left: 50%;
  bottom: calc(100% + var(--pointer-gap));
  transform: var(--translate);
`, W = r(y)`
  left: 50%;
  top: calc(100% + var(--pointer-gap));
  transform: var(--translate);
`, _ = r(y)`
  top: 50%;
  right: calc(100% + var(--pointer-gap));
  transform: var(--translate);
`, M = r(y)`
  top: 50%;
  z-index: ${U.tooltip};
  left: calc(100% + var(--pointer-gap));
  transform: var(--translate);
`, gt = r.div`
  display: inline-flex;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid ${(t) => t.theme.colors.primaryHoverColor};
    outline-offset: 2px;
  }
`, ht = r.div`
  position: relative;
  display: inline-flex;
`, Tt = r.div`
  display: flex;
  justify-content: center;
`, vt = (t, m, p, P) => {
  const g = t.getBoundingClientRect(), x = m.clientHeight + 1, d = m.clientWidth + 1, u = g.top < x, o = g.left < d, c = g.right + d > p - 1, s = g.bottom + x > P - 1, f = u && c, h = u && o, b = s && o, z = s && c;
  if (!(!u && !c && !o && !s)) {
    {
      if (!u && !c && !o)
        return e.TOP;
      if (b && !u && !c)
        return e.TOP_END;
      if (z && !u && !o)
        return e.TOP_START;
      if (!s && !c && !o)
        return e.BOTTOM;
      if (h && !s && !c)
        return e.BOTTOM_END;
      if (f && !s && !o)
        return e.BOTTOM_START;
      if (c && !o)
        return e.LEFT;
      if (!c && o)
        return e.RIGHT;
    }
    return e.TOP;
  }
};
function yt({
  title: t,
  children: m,
  placement: p = e.AUTO,
  arialLabel: P = "Tooltip",
  className: g,
  style: x,
  isDisabled: d = !1,
  showLargeContent: u,
  exceedOverflow: o = !1,
  ...c
}) {
  const s = B(null), f = B(null), h = B(null), [b, z] = A(!1), [j, Y] = A({}), S = p === "above" ? e.TOP : p === "below" ? e.BOTTOM : p, [v, F] = A(
    S === e.AUTO ? e.TOP : S
  );
  C(() => {
    F(
      S === e.AUTO ? e.TOP : S
    );
  }, [p]);
  const { width: E, height: R } = V();
  let n, a;
  const D = w(() => {
    if (!s.current || !f.current)
      return;
    const i = vt(
      s.current,
      f.current,
      E,
      R
    );
    i && i !== v && F(i);
  }, [v, R, E]);
  switch (C(() => {
    o || b && D();
  }, [b, p]), v) {
    case "top":
    case "auto":
      n = tt, a = L;
      break;
    case "top-end":
      n = nt, a = L;
      break;
    case "top-start":
      n = at, a = L;
      break;
    case "left":
      n = et, a = _;
      break;
    case "left-start":
      n = pt, a = _;
      break;
    case "left-end":
      n = ft, a = _;
      break;
    case "right":
      n = ot, a = M;
      break;
    case "right-start":
      n = it, a = M;
      break;
    case "right-end":
      n = st, a = M;
      break;
    case "bottom":
      n = rt, a = W;
      break;
    case "bottom-start":
      n = ct, a = W;
      break;
    case "bottom-end":
      n = lt, a = W;
      break;
    default:
      throw new Error(`Unrecognized Tooltip placement: ${v}`);
  }
  const $ = w(() => {
    h.current && (clearTimeout(h.current), h.current = null);
  }, []), k = w(() => {
    d || f.current && (f.current.style.display = "block", $(), z(!0));
  }, [$, d]), T = w(() => {
    d || ($(), h.current = setTimeout(() => {
      f.current && (f.current.style.display = "none");
    }, 300), z(!1));
  }, [$, d]), Q = w(
    (i) => {
      d || (i.currentTarget.contains(document.activeElement) ? k() : T());
    },
    [T, d, k]
  );
  return C(() => {
    if (o && b) {
      const i = p === "auto" ? e.TOP : p;
      Y(
        N(
          s,
          f,
          i === "above" ? "top" : i === "below" ? "bottom" : i,
          "tooltip"
        )
      );
      const H = () => {
        Y(
          N(
            s,
            f,
            i === "above" ? "top" : i === "below" ? "bottom" : i,
            "tooltip"
          )
        );
      };
      return window.addEventListener("scroll", H, !0), () => {
        window.removeEventListener("scroll", H, !0);
      };
    }
  }, [
    b,
    p,
    o,
    E,
    R,
    u
  ]), /* @__PURE__ */ I(ht, { className: g, style: x, ...c, children: [
    /* @__PURE__ */ O(
      gt,
      {
        onMouseOver: k,
        onMouseOut: T,
        onBlur: T,
        onFocus: Q,
        ref: s,
        children: m
      }
    ),
    t && /* @__PURE__ */ O(
      a,
      {
        $isOpen: b,
        $position: v,
        role: "tooltip",
        "aria-hidden": !b,
        "aria-label": P,
        ref: f,
        style: o ? j : {},
        $exceedOverflow: o,
        children: /* @__PURE__ */ I(Tt, { children: [
          /* @__PURE__ */ O(
            ut,
            {
              onMouseOver: k,
              onMouseOut: T,
              onBlur: T,
              $showLargeContent: u,
              children: t
            }
          ),
          /* @__PURE__ */ O(n, { children: /* @__PURE__ */ O(dt, {}) })
        ] })
      }
    )
  ] });
}
export {
  yt as Tooltip
};
